export default "__VITE_ASSET__DiWJQ2eK__"